/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { badgeSchema } from "./badgeSchema.ts";

export const badgeListSchema = z.object({
	hash_sum: z.string(),
	items: z.array(badgeSchema),
});
